import React from 'react';
import './home.css';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

function Home() {
    const [ref, isVisible] = useScrollAnimation(0.2);

    return (
        <section className="home" id='home'>
            <div className="wrapper coal">
                <div className={`floater fade-in-section ${isVisible ? 'is-visible' : ''}`} ref={ref}>
                    <h1>Energy Corporation</h1>
                    <p>
                        Powering Progress with Precision. At Energy Corporation, we do more than just extract coal; we craft energy solutions with meticulous attention to detail. Our plant, powered by the latest in coal sizing technology, reflects our commitment to precision, empowering clients to achieve their operational goals effectively and efficiently.
                    </p>
                </div>
            </div>
        </section>
    );
}

export default Home;
